<template>
    <svg version="1.1" :height="height" :width="width" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 135 30" style="enable-background:new 0 0 135 30;" xml:space="preserve">
    <g>
	<g transform="translate(34 4.5)">
		<path class="st0" d="M-1.8,12.1c0-1.1,0.2-2.2,0.6-3.3s1-2.1,1.8-3c0.8-0.9,1.7-1.6,2.8-2.1s2.4-0.8,3.8-0.8
			c1.7,0,3.1,0.4,4.3,1.1s2.1,1.7,2.7,2.9L12,8.4c-0.3-0.6-0.6-1-0.9-1.4c-0.4-0.4-0.8-0.7-1.2-0.9C9.4,5.9,8.9,5.7,8.5,5.6
			C8,5.5,7.5,5.5,7.1,5.5c-1,0-1.8,0.2-2.6,0.6C3.8,6.4,3.2,7,2.7,7.6S1.8,9,1.6,9.8c-0.3,0.8-0.4,1.6-0.4,2.4
			c0,0.9,0.1,1.8,0.4,2.6c0.3,0.8,0.7,1.5,1.2,2.2c0.5,0.6,1.2,1.1,1.9,1.5C5.5,18.8,6.3,19,7.2,19c0.5,0,0.9-0.1,1.4-0.2
			s0.9-0.3,1.4-0.5c0.4-0.3,0.9-0.6,1.2-1c0.4-0.4,0.7-0.8,0.9-1.4l2.4,1.4c-0.3,0.7-0.7,1.3-1.3,1.8s-1.2,1-1.8,1.4
			c-0.7,0.4-1.4,0.6-2.2,0.8c-0.8,0.2-1.5,0.3-2.2,0.3c-1.3,0-2.5-0.3-3.6-0.8c-1.1-0.6-2-1.3-2.8-2.2c-0.8-0.9-1.4-1.9-1.8-3.1
			C-1.6,14.4-1.8,13.3-1.8,12.1z"/>
		<path class="st1" d="M22.8,21.8c-1.1,0-2.1-0.2-2.9-0.6c-0.9-0.4-1.6-0.9-2.2-1.5c-0.6-0.6-1.1-1.4-1.4-2.3
			c-0.3-0.9-0.5-1.8-0.5-2.7s0.2-1.8,0.5-2.7c0.3-0.9,0.8-1.6,1.4-2.3c0.6-0.6,1.4-1.2,2.2-1.5c0.9-0.4,1.8-0.6,2.9-0.6
			c1.1,0,2,0.2,2.9,0.6c0.9,0.4,1.6,0.9,2.2,1.5c0.6,0.6,1.1,1.4,1.4,2.3c0.3,0.9,0.5,1.8,0.5,2.7s-0.2,1.8-0.5,2.7
			C29,18.2,28.6,19,28,19.6c-0.6,0.6-1.4,1.2-2.2,1.5C24.9,21.6,23.9,21.8,22.8,21.8z M18.8,14.7c0,0.7,0.1,1.3,0.3,1.8
			c0.2,0.6,0.5,1,0.9,1.5c0.4,0.4,0.8,0.7,1.3,1c0.5,0.2,1,0.4,1.6,0.4s1.1-0.1,1.6-0.4c0.5-0.2,0.9-0.6,1.3-1
			c0.4-0.4,0.7-0.9,0.9-1.5c0.2-0.6,0.3-1.2,0.3-1.8c0-0.6-0.1-1.2-0.3-1.8c-0.2-0.6-0.5-1.1-0.9-1.5c-0.4-0.4-0.8-0.7-1.3-1
			c-0.5-0.2-1-0.4-1.6-0.4c-0.6,0-1.1,0.1-1.6,0.4c-0.5,0.2-0.9,0.6-1.3,1c-0.4,0.4-0.7,0.9-0.9,1.5C18.9,13.4,18.8,14,18.8,14.7z"
			/>
		<path class="st0" d="M44.5,21.5h-2.9v-7.7c0-1.3-0.2-2.2-0.6-2.8c-0.4-0.6-1-0.9-1.8-0.9c-0.4,0-0.8,0.1-1.3,0.2
			c-0.4,0.2-0.8,0.4-1.2,0.7c-0.4,0.3-0.7,0.6-1,1c-0.3,0.4-0.5,0.8-0.7,1.3v8.1h-2.9V7.8h2.6v2.7c0.5-0.9,1.3-1.7,2.3-2.2
			c1-0.5,2.1-0.8,3.3-0.8c0.8,0,1.5,0.1,2,0.4c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.5,1.1,0.6,1.8c0.1,0.7,0.2,1.4,0.2,2.1L44.5,21.5
			L44.5,21.5z"/>
		<path class="st0" d="M60,21.5h-2.9v-7.7c0-1.3-0.2-2.2-0.6-2.8c-0.4-0.6-1-0.9-1.8-0.9c-0.4,0-0.8,0.1-1.3,0.2
			c-0.4,0.2-0.8,0.4-1.2,0.7c-0.4,0.3-0.7,0.6-1,1c-0.3,0.4-0.5,0.8-0.7,1.3v8.1h-2.9V7.8h2.6v2.7c0.5-0.9,1.3-1.7,2.3-2.2
			c1-0.5,2.1-0.8,3.3-0.8c0.8,0,1.5,0.1,2,0.4c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.5,1.1,0.6,1.8c0.1,0.7,0.2,1.4,0.2,2.1L60,21.5
			L60,21.5z"/>
		<path class="st1" d="M69.3,21.8c-1.1,0-2-0.2-2.9-0.6s-1.6-0.9-2.2-1.5c-0.6-0.6-1.1-1.4-1.4-2.3c-0.3-0.9-0.5-1.8-0.5-2.7
			s0.2-1.9,0.5-2.7c0.3-0.9,0.8-1.6,1.4-2.3c0.6-0.7,1.4-1.2,2.2-1.5c0.9-0.4,1.9-0.6,2.9-0.6c1.1,0,2,0.2,2.9,0.6
			c0.9,0.4,1.6,0.9,2.2,1.5s1.1,1.4,1.4,2.2c0.3,0.8,0.5,1.7,0.5,2.7c0,0.2,0,0.4,0,0.6c0,0.2,0,0.3-0.1,0.5h-11
			c0.1,0.6,0.2,1.2,0.4,1.6s0.5,0.9,0.9,1.3c0.4,0.4,0.8,0.6,1.3,0.8c0.5,0.2,1,0.3,1.5,0.3c0.4,0,0.8,0,1.1-0.1s0.7-0.2,1-0.4
			c0.3-0.2,0.6-0.4,0.8-0.7s0.4-0.5,0.6-0.9l2.5,0.7c-0.5,1-1.3,1.9-2.3,2.5C72,21.4,70.8,21.8,69.3,21.8z M73.5,13.6
			C73.4,13,73.3,12.5,73,12c-0.2-0.5-0.5-0.9-0.9-1.2c-0.4-0.3-0.8-0.6-1.3-0.8s-1-0.3-1.5-0.3s-1.1,0.1-1.5,0.3
			c-0.5,0.2-0.9,0.5-1.3,0.8s-0.7,0.8-0.9,1.2c-0.2,0.5-0.4,1-0.4,1.6H73.5z"/>
		<path class="st0" d="M77.6,14.6c0-1,0.2-1.9,0.5-2.7c0.3-0.9,0.8-1.6,1.4-2.3c0.6-0.6,1.4-1.2,2.2-1.5c0.9-0.4,1.9-0.6,2.9-0.6
			c1.4,0,2.6,0.3,3.6,0.9s1.8,1.4,2.3,2.5l-2.8,0.9c-0.3-0.6-0.8-1-1.3-1.4c-0.6-0.3-1.2-0.5-1.9-0.5c-0.6,0-1.1,0.1-1.6,0.3
			c-0.5,0.2-0.9,0.5-1.3,1c-0.4,0.4-0.7,0.9-0.9,1.5c-0.2,0.6-0.3,1.2-0.3,1.9c0,0.7,0.1,1.3,0.3,1.8c0.2,0.6,0.5,1.1,0.9,1.5
			s0.8,0.7,1.3,1c0.5,0.2,1,0.4,1.6,0.4c0.4,0,0.7,0,1-0.1c0.4-0.1,0.7-0.2,1-0.4s0.5-0.4,0.8-0.6c0.2-0.2,0.4-0.5,0.5-0.7l2.8,0.8
			c-0.5,1-1.2,1.9-2.3,2.5c-1.1,0.7-2.3,1-3.8,1c-1.1,0-2-0.2-2.9-0.6s-1.6-0.9-2.2-1.6c-0.6-0.7-1.1-1.4-1.4-2.3
			C77.7,16.5,77.6,15.6,77.6,14.6L77.6,14.6z"/>
		<path class="st0" d="M100.5,20.8c-0.4,0.2-0.9,0.4-1.5,0.6s-1.3,0.3-2.1,0.3c-0.5,0-0.9-0.1-1.3-0.2c-0.4-0.1-0.8-0.3-1.1-0.5
			s-0.5-0.6-0.7-1c-0.2-0.4-0.3-0.9-0.3-1.4V10h-1.8V7.8h1.8V3.3h2.9v4.5h3V10h-3v7.6c0,0.5,0.2,0.8,0.5,1.1c0.3,0.2,0.6,0.3,1,0.3
			s0.8-0.1,1.2-0.2c0.4-0.1,0.6-0.3,0.8-0.3L100.5,20.8z"/>
	</g>
	<g>
		<path class="st0" d="M9.2,11.2L9.2,11.2L9.2,11.2z"/>
		<path class="st0" d="M13.6,11.2L13.6,11.2L13.6,11.2L13.6,11.2z"/>
		<path class="st0" d="M13.6,11.2L13.6,11.2L13.6,11.2z"/>
		<path class="st0" d="M11.4,22.6L11.4,22.6L11.4,22.6z"/>
		<path class="st0" d="M15.8,22.6L15.8,22.6L15.8,22.6z"/>
		<path class="st0" d="M11.4,22.6h4.4l-1.5-2.5h-1.5L11.4,22.6z"/>
		<path class="st0" d="M9.2,18.8h2.9l0.7-1.3L11.4,15L9.2,18.8z"/>
		<path class="st0" d="M14.4,17.5l0.7,1.3H18L15.8,15L14.4,17.5z"/>
		<path class="st0" d="M7,22.6L7,22.6L7,22.6z"/>
		<path class="st0" d="M7,22.6l-2.2-3.8v0l-4.4,7.6h8.8L7,22.6z"/>
		<path class="st0" d="M7,22.6l-2.2-3.8L7,22.6L7,22.6L7,22.6z"/>
		<path class="st0" d="M9.2,26.4l-2.2-3.8h0L9.2,26.4z"/>
		<path class="st0" d="M22.4,18.8l-2.2,3.8L18,26.4h8.8L22.4,18.8z"/>
		<path class="st0" d="M22.4,18.8l-2.2,3.8L22.4,18.8z"/>
		<path class="st0" d="M20.2,22.6L18,26.4v0L20.2,22.6z"/>
		<path class="st0" d="M13.6,11.2H18l-4.4-7.6l-4.4,7.6H13.6z"/>
		<path class="st0" d="M7.1,22.6h4.4l-2.2-3.8L7.1,22.6z"/>
		<path class="st0" d="M7,22.6L7,22.6L7,22.6z"/>
		<path class="st0" d="M20.2,22.6L18,18.8l-2.2,3.8L20.2,22.6z"/>
		<path class="st0" d="M15.8,15L15.8,15L15.8,15L15.8,15L15.8,15z"/>
		<path class="st0" d="M15.8,15l-2.2-3.8L11.4,15H15.8z"/>
		<path class="st0" d="M18,26.4l-2.2-3.8l-2.2,3.8L18,26.4z"/>
		<path class="st0" d="M13.6,26.4L13.6,26.4l2.2-3.8v0L13.6,26.4z"/>
		<path class="st0" d="M11.4,22.6l-2.2,3.8h4.4L11.4,22.6z"/>
		<path class="st0" d="M11.4,22.6l-2.2,3.8v0L11.4,22.6L11.4,22.6z"/>
		<path class="st0" d="M9.2,18.8L7,15h0h0v0l-2.2,3.8v0H9.2z"/>
		<path class="st0" d="M9.2,18.8L7.1,15h0L9.2,18.8z"/>
		<path class="st0" d="M4.9,18.8L4.9,18.8L4.9,18.8z"/>
		<path class="st0" d="M20.2,15L18,18.8h4.4L20.2,15z"/>
		<path class="st0" d="M18,18.8l2.2-3.8L18,18.8z"/>
		<path class="st0" d="M11.4,15L11.4,15L11.4,15z"/>
		<path class="st0" d="M11.4,15l-2.2-3.8L7,15H11.4z"/>
		<path class="st0" d="M11.4,15l-2.2-3.8v0L11.4,15L11.4,15z"/>
		<path class="st0" d="M11.4,15L11.4,15L11.4,15z"/>
		<path class="st0" d="M11.4,15L11.4,15L11.4,15z"/>
		<path class="st0" d="M20.2,15L18,11.2L15.8,15H20.2z"/>
		<path class="st0" d="M20.2,15L20.2,15L20.2,15z"/>
		<path class="st1" d="M16.1,20.2h-4.9l2.5-4.3L16.1,20.2z M11.7,19.9h3.9l-1.9-3.3L11.7,19.9z"/>
	</g>
</g>
    </svg>
</template>

<script>
    export default {
        name: 'IconYpoConnectLogo',
        props: {
            width: {
                type: [Number, String],
                default: 20,
            },
            height: {
                type: [Number, String],
                default: 20,
            },
        },
    };
</script>

<style>
    .st0 {
        fill-rule: evenodd;
        clip-rule: evenodd;
        fill: #ffffff;
    }

    .st1 {
        fill: #ffffff;
    }
</style>
